import React from 'react';
import { connect } from 'react-redux';
import { requestClient } from '../../../store/client-manager/ClientManagerActions';
import ClientTest from '../components/ClientTest';

class ClientInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cl: null,
    };
  }

  componentDidMount() {
    this.props
      .getClient(this.props.code, {
        tenantId: this.props.tenantId,
      })
      .then((response) =>
        this.setState({
          cl: response.payload.data ? response.payload.data : null,
        }),
      );
  }

  render() {
    return <div>{this.state.cl && <ClientTest data={this.state.cl} />}</div>;
  }
}

export default connect(
  (state) => ({
    data: state.clientmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getClient: (employerCodeNumber, params) =>
      dispatch(requestClient(employerCodeNumber, params)),
  }),
)(ClientInfo);



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/ClientInfo.js